const spendingLimits = {
  'spendingLimits.channels': 'Channels',
  'spendingLimits.errorChangeChannel': 'Channel update error',
  'spendingLimits.value': 'Limit value',
  'spendingLimits.confirm': 'Confirm',
  'spendingLimits.limitValueUpdateSuccess': 'Limit value updated!',
  'spendingLimits.resetIn': 'Reset in',
};

export default spendingLimits;
